/** A small tap on build and dig in the apps; nothing on the web. */
import { Haptics, ImpactStyle, NotificationType } from '@capacitor/haptics';

import { isNative } from './env';

export type HapticKind = 'build' | 'dig' | 'refused' | 'select';

export function haptic(kind: HapticKind): void {
  if (!isNative) return;
  const run = async (): Promise<void> => {
    if (kind === 'build') await Haptics.impact({ style: ImpactStyle.Light });
    else if (kind === 'dig') await Haptics.impact({ style: ImpactStyle.Medium });
    else if (kind === 'refused') await Haptics.notification({ type: NotificationType.Warning });
    else await Haptics.selectionChanged();
  };
  run().catch(() => undefined);
}
